import {
    DOCUMENT_TYPE,
    SOURCE_SYSTEM,
    DATE_RANGE,
    SEARCH_VALUE,
    STAGE
  } from "./consts";
import { z } from "zod";

export const schema = z.object({
  [DOCUMENT_TYPE]: z.string().optional(),
  [SOURCE_SYSTEM]:z.string().optional(),
  [STAGE]:z.string().optional(),
  [SEARCH_VALUE]:z.string().optional(),
  [DATE_RANGE]: z.any().optional(),

});

export type formValues = z.infer<typeof schema>;